module.exports = __webpack_public_path__ + "static/img/sign@2x.4db89859.png";